import { FC } from 'react'

import { Txt } from 'src/components/atoms'
import { RoleIcon } from 'src/components/molecules'

import { RoleEntity } from 'src/types'

type BaseProps = {
  size?: 's' | 'm'
  className?: string
}

type SimpleProps = {
  roleName: string
  roleDisplayName: string
}
type RoleProps = {
  role: RoleEntity
}

type Props = BaseProps & (SimpleProps | RoleProps)

export const UserRoleTxt: FC<Props> = ({ size = 'm', className, ...otherProps }) => {
  const roleName = Object.prototype.hasOwnProperty.call(otherProps, 'role')
    ? (otherProps as RoleProps).role.name
    : (otherProps as SimpleProps).roleName
  const roleDisplayName = Object.prototype.hasOwnProperty.call(otherProps, 'role')
    ? (otherProps as RoleProps).role.displayName
    : (otherProps as SimpleProps).roleDisplayName

  return (
    <div className={className}>
      <div className="tw-centering">
        <RoleIcon roleName={roleName} size={size} className="tw-text-standardText-disable" />
        <Txt sizeType={size} className="tw-ml-s-4">
          {roleDisplayName}
        </Txt>
      </div>
    </div>
  )
}
